import React, { useState } from "react";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { TableWithStickyHeader } from "../../uiControls/tableWithStickyHeader";
import { ColumnLookupUpdate } from "./columnLookupUpdate";
import { ConfirmationDialog } from "../../common/confirmationDialog";
import { AddNew } from "../../uiControls/addNew";

const columnLookupColumns = [
  { label: "Column Name", keyField: "columnKey", dataField: "name" },
];

const columnLookupSearchColumns = ["name"];

export const ColumnLookupConfig = () => {
  const [updateOpen, setUpdateOpen] = useState(false);
  const [columnLookupEdit, setColumnLookupEdit] = useState(null);
  const [columnLookupAttributes, setColumnLookupAttributes] = useState({
    columnKey: 0,
    name: "",
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmationDialogAttributes, setConfirmationDialogAttributes] =
    useState({});

  const { sendRequest: fetchColumnLookupDetails } = useHttpRequests();

  const columnLookupEditHandler = (e, key) => {
    e.stopPropagation();
    if (updateOpen) {
      //alert("Are you sure to discard your changes?");
      //TODO: confirmation for data loss
      return false;
    }

    const getColumnLookupDetails = (columnLookupObj) => {
      if (
        !columnLookupObj ||
        !columnLookupObj.isSuccess ||
        columnLookupObj.errorResponse
      ) {
        console.log("Column fetch response returns error");
        return;
      }

      setColumnLookupAttributes({
        columnKey: columnLookupObj["columns"]["columnKey"],
        name: columnLookupObj["columns"]["name"],
      });

      setColumnLookupEdit(true);
      setUpdateOpen(true);
    };

    fetchColumnLookupDetails(
      { url: "columns/" + key, method: "GET", header: true },
      getColumnLookupDetails
    );
  };

  const changeColumnLookupStatus = (e, key, status, name) => {
    e.stopPropagation();
    if (updateOpen || dialogOpen) {
      return false;
    }
    setConfirmationDialogAttributes({
      title: "Column status change confirmation!",
      message:
        "Are you sure to mark " +
        (status ? "active" : "inactive") +
        " the " +
        name +
        "?",
      confirmText: "Yes",
      cancelText: "No",
      url: "Columns/",
      keyField: "columnKey",
      key: key,
      status: status,
      messageTitle: name,
    });
    setDialogOpen(true);
  };

  const getUrl = (params) => {
    return "Columns?" + params;
  };

  const columnLookupDetailProps = {
    setUpdateOpen,
    columnLookupEdit,
    setColumnLookupEdit,
    columnLookupAttributes,
  };

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        height: "calc(100vh - 160px)",
      }}
    >
      <ConfirmationDialog
        open={dialogOpen}
        setDialogOpen={setDialogOpen}
        confirmationDialogAttributes={confirmationDialogAttributes}
      />
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          gap: "20px",
          width: "100%",
        }}
      >
        {!updateOpen && (
          <>
            <TableWithStickyHeader
              pagging={false}
              columns={columnLookupColumns}
              url={getUrl}
              sourceObj="columns"
              editHandler={columnLookupEditHandler}
              updateOpen={updateOpen || dialogOpen}
              searchOnColumns={columnLookupSearchColumns}
              changeStatus={changeColumnLookupStatus}
              searchPlace="right"
            />

            <AddNew
              onClickCall={() => {
                setColumnLookupAttributes({
                  columnKey: 0,
                  name: "",
                });
                setUpdateOpen(true);
              }}
            />
          </>
        )}
      </div>

      {updateOpen && (
        <div
          style={{
            display: "flex",
            width: window.innerWidth <= 1366 ? "100%" : "65%",
          }}
        >
          <ColumnLookupUpdate {...columnLookupDetailProps} />
        </div>
      )}
    </div>
  );
};
